export default __webpack_public_path__ + "static/media/BCP Disclosure Summary MMS V1.47eacbd5.pdf";